import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import styles from './ellipsis.scss'

class Ellipsis extends PureComponent {

	render() {
		return (
			<span>
				<i styleName='ell'>.</i>
				<i styleName='ell'>.</i>
				<i styleName='ell'>.</i>
			</span>
		)
	}
}

export default CSSModules(Ellipsis, styles, {allowMultiple: true})
